/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_DescriptionInputs */



/**
* | output |
* | --- |
* | "Work with AWP Marine: open roles for marine inspectors and the UK office, and how to join our inspector network." |
*
* @param {Careers_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const careers_description = /** @type {((inputs?: Careers_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("加入 AWP Marine：船舶检查员和英国办公室的在招职位，以及如何加入我们的检查员网络。")
	return /** @type {LocalizedString} */ ("Work with AWP Marine: open roles for marine inspectors and the UK office, and how to join our inspector network.")
});